// removed by extract-text-webpack-plugin
module.exports = {"caption":"_1bb43yq9-1nFiZJYna6Qw_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Valve/style.css
// module id = 344
// module chunks = 0